//auth
export const AUTHENTICATE = 'AUTHENTICATE';
export const LOGOUT = 'LOGOUT';
export const CHANGE_FIRST_LOGGEDIN = 'CHANGE_FIRST_LOGGEDIN';
export const GET_DATA_PROFILE = 'GET_DATA_PROFILE';